// Generated by CoffeeScript 2.5.1
export default function(app) {
  return console.log(`%c
      &        .:@@@@@:.
    .@@@.    .x@@@@@@@@%&,
   .@@@@@.  .&@@@@@@@@@@@&.
  :@@@@@@@. .&@@@@@@@@@@@&.
 :@@@@@@@@@: '&@@@@@@@@@&'    Bukwild: Design and technology for innovators.
:@@@@@@@@@@@:  '"@@@@@"'      bukwild.com`, 'color: #2683cc; font-weight: bold');
};
